import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import styled from "@emotion/styled"
import Chevron from "components/Icons/Chevron"
import useMedia from "../../hooks/useMedia"

const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 351px;
  max-width: 248px;
  gap: 18px 40px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    max-height: 100%;
    max-width: 100%;
    flex-wrap: nowrap;
  }
`

const Item = styled.a`
  font-size: 16px;
  text-decoration: none;
  max-width: 300px;
`

const ItemHeading = styled.h3`
  font-size: 22px;
  line-height: 24px;
  font-weight: 600;
  margin: 0;
  color: #1c1c1c;
`

const ItemTitle = styled.p`
  font-size: 18px;
  line-height: 22px;
  font-weight: 500;
  margin: 0;
  color: #8b8b95;
  box-sizing: border-box;
  border: 1px solid transparent;
  width: fit-content;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 16px;
    line-height: 20px;
  }

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    border-bottom: 1px solid ${({ theme }) => theme.palette.primary.main};
  }
`

const ItemInfoContainer = styled.div`
  position: relative;
  width: fit-content;
  margin-bottom: 20px;

  ${({ theme }) => theme.breakpoints.down("xl")} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`

const ItemHeadingContainer = styled.div`
  position: relative;
  width: fit-content;
`

const GreenDot = styled.span`
  display: block;
  position: absolute;
  top: -2px;
  right: -8px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #38b148;
  pointer-events: none;
`
const ChevronIcon = styled(Chevron)`
  transform: ${({ isRotated }) => (isRotated ? "rotate(-180deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease-in-out;
`

const ChevronButton = styled.button`
  background: none;
  border: none;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;

  ${({ theme }) => theme.breakpoints.up("xl")} {
    display: none;
  }
`

const HeaderCommonNavList = ({ title, subItems }) => {
  const isXLScreen = useMedia(["(max-width: 1279px)"], [false], true)
  const [visible, setIsVisible] = useState(false)

  const handleSwitch = () => setIsVisible((prev) => !prev)

  useEffect(() => {
    if (title.length === 1) {
      setIsVisible(true)
    }

    if (!isXLScreen) {
      setIsVisible(false)
      return
    }

    setIsVisible(true)
  }, [isXLScreen, title])
  return (
    <NavContainer>
      {title.length !== 1 && (
        <ItemInfoContainer>
          <ItemHeadingContainer>
            <ItemHeading>{title}</ItemHeading>
            <GreenDot />
          </ItemHeadingContainer>
          <ChevronButton onClick={handleSwitch}>
            <ChevronIcon isRotated={visible} />
          </ChevronButton>
        </ItemInfoContainer>
      )}
      {(visible || title.length === 1) && (
        <Container>
          {subItems.map((subItem) => (
            <Item href={subItem.link} key={subItem.title}>
              <ItemTitle>{subItem.title}</ItemTitle>
            </Item>
          ))}
        </Container>
      )}
    </NavContainer>
  )
}

HeaderCommonNavList.propTypes = {
  title: PropTypes.string.isRequired,
  subItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      link: PropTypes.string.isRequired,
    }),
  ).isRequired,
}

export default HeaderCommonNavList
